import { render } from "./add.vue?vue&type=template&id=78141392"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Stage-integrated-sugang-admin-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__